import { render, staticRenderFns } from "./recuperacion.vue?vue&type=template&id=040e16b8"
import script from "./recuperacion.vue?vue&type=script&lang=js"
export * from "./recuperacion.vue?vue&type=script&lang=js"
import style0 from "./recuperacion.vue?vue&type=style&index=0&id=040e16b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports